// extracted by mini-css-extract-plugin
module.exports = {"externalTopBar":"style_externalTopBar__6MqTl","externalContentBox":"style_externalContentBox__10sXD","externalTitle":"style_externalTitle__GEK9t"};